import { getStatusInfo } from "../../Pages/Collections/GetStatusStyle";

//Expansion data in both collection and scheme
export const ExpandedCollectionData = (handleDelete,permitted) => {
  const renderPaymentColumn = (paymentType) => (text, record) => {
    const status = getStatusInfo(record?.status)?.statusText;

    // Find the payment entry for the given type
    const paymentEntry = record?.payments?.find((p) => p.type === paymentType);

    return (
      <div className="mx-3" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {paymentEntry ? `${paymentEntry.amount}` : "NA"}
        {paymentEntry?.amount > 0 && status == "Processing" && permitted && paymentEntry?.type !=="UPI"  && (
          <i
            style={{
              border: "3px solid",
              borderRadius: 15,
              padding: 5,
              cursor: "pointer",
            }}
            className="fas fa-trash text_master"
            onClick={() => handleDelete(paymentEntry)}
          ></i>
        )}
      </div>
    );
  };

  return [
    {
      title: "Chitty Number",
      dataIndex: "chittyId",
      render: (text,itemSet) => <>{itemSet?.item?.chittyId}</>,
    },
    {
      title: "Chittal No",
      dataIndex: "chittalNo",
      render: (text, itemSet) => <>{itemSet?.item?.chittalNo}</>,
    },
    {
      title: "Paid by cash",
      dataIndex: "paidByCash",
      render: renderPaymentColumn("Cash"), 
    },
    {
      title: "Paid by cheque",
      dataIndex: "paidByCheque",
      render: renderPaymentColumn("Cheque"), 
    },
    {
      title: "Paid by UPI",
      dataIndex: "paidByUPI",
      render: renderPaymentColumn("UPI"), 
    },
  ];
};


export const ExpandedSchemeData = [
  {
    title: "Chitty Number",
    dataIndex: "chittyId",
    render: (text,itemSet) =>{
      return (<>{itemSet?.item?.chittyId}</>)
    },
  },
  {
    title: "Chittal No",
    dataIndex: "chittalNo",

    render: (text,itemSet) =>{
      // debugger
      return (<>{itemSet?.item?.chittalNo}</>)
},
  },
  {
    title: "Branch",
    dataIndex: "",
    render: (text,itemSet) =>{
      return (<>{itemSet?.branchDetails}</>)
  },
  },
  // {
  //   title: "Transaction ID",
  //   dataIndex: "transactionId",
  //   render: (text) => text || "NA",
  // },
  // {
  //   title: "Post Id",
  //   dataIndex: "paymentDetails",
  //   render: (paymentDetails) => 
  //   <>
  //  {paymentDetails?.map((itm, index) => (
  // <span key={itm?.syncId}>
  //   {itm?.syncId}
  //   {index < paymentDetails.length - 1 && ", "}
  // </span>
  //  ))}
  //   </>,
  // },
];

//Status in collection and scheme page 
export const casbaStatus = [
    {
      value: "0",
      label: "Pending",
    },
    {
      value: "1",
      label: "Success",
    },
    {
      value: "2",
      label: "Processing",
    },
  ];


//Default column and width for the reports in collection
export const defaultColumnWidths = {
    agentId: 50,
    agentName: 100,
    customerName: 100,
    transactionId: 100,
    amountPaid: 75,
    chittyId: 75,
    chittalNo: 75,
    branchDetails: 150,
    paidByCash: 75,
    paidByCheque: 75,
    paidByUPI: 75,
    status: 80,
  };
  
  //intial values for the modal
  export const AlertinitialValue = {
    show: false,
    type: "",
    message: "The status has not been updated.",
    isSuccess: true,
    isFalse:true,
  };
  
  //Download options
  export const downloadOptions = [
    {
      type: "pdf",
      label: "Download as PDF",
      icon: "far fa-file-pdf",
      iconColor: "danger",
    },
    {
      type: "csv",
      label: "Download as CSV",
      icon: "fas fa-file-csv",
      iconColor: "primary",
    },
    {
      type: "excel",
      label: "Download as Excel",
      icon: "fas fa-file-excel",
      iconColor: "success",
    },
  ];
  
//Data Columns for reports in collection
export const dataColumn = [
  {
    title: "Sl No.",
    dataKey: "key",
  },
  {
    title: "Branch",
    dataKey: "branchName",
  },
  {
    title: "Agent Name",
    dataKey: "agentName",
  },
  {
    title: "Agent ID",
    dataKey: "agentId",
  },
  {
    title: "Customer Name",
    dataKey: "customerName",
  },
  {
    title: "Chitty No",
    dataKey: "chittyId",
  },
  {
    title: "Chittal No",
    dataKey: "chittalNo",
  },
  {
    title: "Date & Time",
    dataKey: "created_date",
  },
  {
    title: "Transaction ID",
    dataKey: "transactionId",
  },
  // {
  //   title: "Posting Id",
  //   dataKey: "syncId",
  // },
  // need to add posting id
  {
    title: "Mode Of Collection",
    dataKey: "collectionMode",
  },
  {
    title: "Amount Collected",
    dataKey: "amountPaid",
  },
  {
    title: "Casba Sync Status",
    dataKey: "status",
  },
];

  //data columns for scheme reports
  export const dataColumnScheme = [
    {
      title: "Customer Name",
      dataKey: "customerName",
    },
    {
      title: "Transaction ID",
      dataKey: "transactionId",
    },
    {
      title: "Amount Collected",
      dataKey: "amountPaid",
    },
    {
      title: "Chitty No",
      dataKey: "chittyId",
    },
    {
      title: "Chittal No",
      dataKey: "chittalNo",
    },
    {
      title: "Branch",
      dataKey: "branchName",
    },
    {
      title: "Cash Amount",
      dataKey: "paidByCash",
    },
    {
      title: "Cheque Amount",
      dataKey: "paidByCheque",
    },
    {
      title: "UPI Amount",
      dataKey: "paidByUPI",
    },
    {
      title: "Casba Sync Status",
      dataKey: "status",
    },
  ];
  

  export const dataColumnCsv = [
    { header: "Sl No.", key: "key", width: 10 },
    { header: "Branch", key: "branchName", width: 15 },
    { header: "Agent Name", key: "agentName", width: 25 },
    { header: "Agent ID", key: "agentId", width: 15 },
    { header: "Customer Name", key: "customerName", width: 25 },
    { header: "Chitty No", key: "chittyId", width: 15 },
    { header: "Chittal No", key: "chittalNo", width: 15 },
    { header: "Date & Time", key: "created_date", width: 20 },
    { header: "Transaction ID", key: "transactionId", width: 20 },
    { header: "Mode Of Collection", key: "collectionMode", width: 20 },
    { header: "Amount Collected", key: "amountPaid", width: 15 },
    { header: "Casba Sync Status", key: "status", width: 15 },
  ];

 export  const dataColumnCsvScheme = [
    { header: "Customer Name", key: "customerName", width: 25 },
    { header: "Transaction ID", key: "transactionId", width: 15 },
    { header: "Amount Collected", key: "amountPaid", width: 15 },
    { header: "Chitty No", key: "chittyId", width: 15 },
    { header: "Chittal No", key: "chittalNo", width: 15 },
    { header: "Branch", key: "branchName", width: 15 },
    { header: "Cash Amount", key: "paidByCash", width: 15 },
    { header: "Cheque Amount", key: "paidByCheque", width: 15 },
    { header: "UPI Amount", key: "paidByUPI", width: 15 },
    { header: "Casba Sync Status", key: "status", width: 15 },
  ]

  //UPI column in reports
 export const upiColumn = [
    {
      title: "Date & Time",
      dataKey: "created_date",
    },
    {
      title: "Branch",
      dataKey: "branchName",
    },
    {
      title: "Agent Name",
      dataKey: "agentName",
    },
    {
      title: "Agent ID",
      dataKey: "agentId",
    },
    {
      title: "Customer Name",
      dataKey: "customerName",
    },
    {
      title: "Transaction ID",
      dataKey: "transactionId",
    },
    {
      title: "Amount Collected",
      dataKey: "amountPaid",
    },
  ];  

  export const upiColumnCsv = [
    { header: "Date & Time", key: "created_date", width: 25 },
    { header: "Branch", key: "branchName", width: 15 },
    { header: "Agent Name", key: "agentName", width: 25 },
    { header: "Agent ID", key: "agentId", width: 15 },
    { header: "Customer Name", key: "customerName", width: 25 },
    { header: "Transaction ID", key: "transactionId", width: 15 },
    { header: "Amount Collected", key: "amountPaid", width: 15 },
  ]

  export const getDownloadFormat = type =>{
    switch (type) {
      case "pdf":
        return ".pdf";
      case "csv":
        return ".csv";
      case "excel":
        return ".xlsx";
      default:
        return "";
    }
  }


  
export const paymentFilters = [
  {
    label: "Cash",
    value: 1
  },
  {
    label: "Cheque",
    value: 2
  },
  {
    label: "UPI Success",
    value: 3
  },
  {
    label: "UPI Failed",
    value: 4
  },
  {
    label: "UPI Pending",
    value: 5
  },
  {
    label: "Cheque Rejected",
    value: 6
  },
]